<template>
  <div :class="{ 'action-panel': !isWaitingOnly }">
    <b-alert v-if="showFinanceWaitingAlert" show variant="info" class="mb-0">
      Menunggu cabang mengunggah bukti transfer pengembalian dana.
    </b-alert>
    <b-alert v-else-if="showBranchWaitingAlert" show variant="info" class="mb-0">
      Menunggu pengecekan bukti transfer pengembalian dana.
    </b-alert>
    <div v-else-if="showUploadAction">
      <h6>Bukti Pengembalian Nasabah</h6>
      <p class="small text-muted">Cabang mengunggah bukti transfer pengembalian dana.</p>
      <div class="form-content-wrapper disbursement-upload-wrapper mb-0 mt-2">
        <FotoPendukung
          :fotoPendukung="buktiPengembalianFoto"
          :length="1"
          :minLength="1"
          :isRemove="false"
          :isNotShowCam="true"
          gadai="true"
          @showModalPreview="openBuktiPengembalianFotoPreview"
          @onChange="onUploadBuktiPengembalian"
          :customClass="'hide-upload-label'"
        />
      </div>
      <b-button
        variant="pgiBtn"
        class="mt-3"
        :disabled="!buktiPengembalianPublicUrl || isUploadingBuktiPengembalian"
        @click="openModalConfirmBuktiPengembalian"
      >
        Submit
      </b-button>
    </div>
    <div v-else-if="showConfirmAction">
      <h6>Konfirmasi Dana Masuk PGI</h6>
      <p class="small text-muted">Finance mengkonfirmasi dana masuk dan menyelesaikan transaksi.</p>
      <b-button variant="pgiBtn" @click="openModalConfirmDanaMasukPgi">
        Konfirmasi
      </b-button>
    </div>

    <b-modal id="modal-preview-foto-pengembalian" size="lg" title="Foto Bukti Pengembalian" ok-only ok-title="Tutup">
      <b-img v-if="activeFotoPreview" :src="activeFotoPreview" fluid />
    </b-modal>
    <ModalConfirm
      id="modal-confirm-bukti-pengembalian"
      title="Konfirmasi Bukti Pengembalian"
      :isSubmitting="isSubmittingBuktiPengembalian"
      desc="Apakah anda yakin untuk mengunggah bukti pengembalian nasabah?"
      @submit="onSubmitBuktiPengembalian"
    />
    <ModalConfirm
      id="modal-confirm-dana-masuk-pgi"
      title="Konfirmasi Dana Masuk PGI"
      :isSubmitting="isSubmittingDanaMasukPgi"
      desc="Apakah anda yakin untuk mengkonfirmasi dana masuk PGI?"
      @submit="onSubmitDanaMasukPgi"
    />
  </div>
</template>

<script>
import FotoPendukung from '@/components/webcam/FotoPendukung'
import { parseDocumentUrls } from './disbursementPendingUtils'

export default {
  name: 'DisbursementPendingRefundAction',
  components: {
    FotoPendukung,
  },
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
    isBranchRole: {
      type: Boolean,
      default: false,
    },
    isFinanceRole: {
      type: Boolean,
      default: false,
    },
    refreshDetail: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      buktiPengembalianFoto: this.createUploadFoto(0),
      buktiPengembalianPublicUrl: '',
      activeFotoPreview: '',
      isUploadingBuktiPengembalian: false,
      isSubmittingBuktiPengembalian: false,
      isSubmittingDanaMasukPgi: false,
    }
  },
  computed: {
    refundDocuments() {
      return parseDocumentUrls(this.disbursementPending.pathFotoRefund)
    },
    hasRefundDocuments() {
      return this.refundDocuments.length > 0
    },
    showUploadAction() {
      return this.isBranchRole && !this.hasRefundDocuments
    },
    showConfirmAction() {
      return this.isFinanceRole && this.hasRefundDocuments
    },
    showFinanceWaitingAlert() {
      return this.isFinanceRole && !this.hasRefundDocuments
    },
    showBranchWaitingAlert() {
      return this.isBranchRole && this.hasRefundDocuments
    },
    isWaitingOnly() {
      return this.showFinanceWaitingAlert || this.showBranchWaitingAlert
    },
  },
  methods: {
    createUploadFoto(index) {
      return {
        index,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: 'Pilih Foto',
        publicUrl: '',
        fileName: '',
      }
    },
    async onUploadBuktiPengembalian(file) {
      if (!file) return

      if (!this.isImageFile(file)) {
        this.resetBuktiPengembalianUpload()
        this.$helper.toastErr(this, 'File harus berupa gambar.')
        return
      }

      this.isUploadingBuktiPengembalian = true
      this.buktiPengembalianPublicUrl = ''

      this.$store.dispatch('loading/show')
      let response

      try {
        response = await this.$helper.uploadPresigned({
          vue: this,
          path: 'gadai-disburse/create-refund-url',
          fileUpload: this.$helper.createSafeFileCopy(file),
        })
      } catch (error) {
        this.resetBuktiPengembalianUpload()
        this.$helper.parseError(this, error)
        return
      } finally {
        this.isUploadingBuktiPengembalian = false
        this.$store.dispatch('loading/hide')
      }

      if (!response.success) {
        this.resetBuktiPengembalianUpload()
        this.$helper.toastErr(this, 'Gagal upload bukti pengembalian. Silakan coba lagi.')
        return
      }

      this.buktiPengembalianPublicUrl = response.publicUrl
    },
    openBuktiPengembalianFotoPreview() {
      if (!this.buktiPengembalianFoto.activeFotoPendukungBase64) return

      this.activeFotoPreview = this.buktiPengembalianFoto.activeFotoPendukungBase64
      this.$bvModal.show('modal-preview-foto-pengembalian')
    },
    openModalConfirmBuktiPengembalian() {
      this.$bvModal.show('modal-confirm-bukti-pengembalian')
    },
    async onSubmitBuktiPengembalian() {
      const id = this.disbursementPending.id

      if (!id) {
        this.$helper.toastErr(this, 'ID disbursement tidak ditemukan.')
        return
      }

      if (!this.buktiPengembalianPublicUrl) {
        this.$helper.toastErr(this, 'Upload bukti pengembalian terlebih dahulu.')
        return
      }

      const payload = {
        pathFotoRefund: [this.buktiPengembalianPublicUrl],
      }

      this.isSubmittingBuktiPengembalian = true

      try {
        await this.$axios.post(`gadai-disburse/${id}/upload-refund`, payload)
        await this.refreshDetail()
        this.$bvModal.hide('modal-confirm-bukti-pengembalian')
        this.$helper.toastSucc(this, 'Bukti pengembalian berhasil dikirim.')
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isSubmittingBuktiPengembalian = false
      }
    },
    openModalConfirmDanaMasukPgi() {
      this.$bvModal.show('modal-confirm-dana-masuk-pgi')
    },
    async onSubmitDanaMasukPgi() {
      const id = this.disbursementPending.id

      if (!id) {
        this.$helper.toastErr(this, 'ID disbursement tidak ditemukan.')
        return
      }

      this.isSubmittingDanaMasukPgi = true

      try {
        await this.$axios.post(`gadai-disburse/${id}/finish-refund`)
        await this.refreshDetail()
        this.$bvModal.hide('modal-confirm-dana-masuk-pgi')
        this.$helper.toastSucc(this, 'Dana masuk PGI dikonfirmasi. Transaksi selesai.')
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isSubmittingDanaMasukPgi = false
      }
    },
    resetBuktiPengembalianUpload() {
      this.buktiPengembalianPublicUrl = ''
      this.buktiPengembalianFoto.fotoBarangPendukung = null
      this.buktiPengembalianFoto.fotoBarangPendukungBase64 = null
      this.buktiPengembalianFoto.activeFotoPendukungBase64 = null
      this.buktiPengembalianFoto.checkFotoBarangPendukung = false
      this.buktiPengembalianFoto.publicUrl = ''
      this.buktiPengembalianFoto.fileName = ''
    },
    isImageFile(file) {
      return file && file.type && file.type.startsWith('image/')
    },
  },
}
</script>

<style scoped>
.action-panel {
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
  padding: 16px;
}

.disbursement-upload-wrapper .form-dynamic-wrapper {
  max-width: 100%;
}
</style>
